import * as THREE from 'three'
import Experience from "../Experience.js";
import Paves from './assets/Paves.js';
import vertexPaves from '../../shaders/paves/vertex.glsl'
import fragmentPaves from '../../shaders/paves/fragment.glsl'
import anim from '../Utils/Anim.js';


export default class Tableau2 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = _options.targetPos
        // 
        this.setMaterials()


        this.experience.renderer.darkMaterial.transparent = true
        if (!this.isDestroyed) {
            anim.to(this.experience.renderer.darkMaterial, {
                opacity: 0,
                duration: 1,
                onComplete: () => {
                    if (this.isDestroyed) return
                    if (!this.isDestroyed) {
                        this.paves = new Paves({
                            targetPos: this.targetPos,
                            materials: this.materials

                        })

                    }

                }
            })

        }





        this.setDebug()



    }
    setMaterials() {


        this.pavesMat = new THREE.ShaderMaterial({
            vertexShader: vertexPaves,
            fragmentShader: fragmentPaves,
            transparent: true,
            uniforms: {
                u_fog: new THREE.Uniform(1.83),
                u_targetPos: new THREE.Uniform(new THREE.Vector3(0, 0, 0)),
                u_appear: new THREE.Uniform(1),
            }
        })

        this.materials = {
            paves: this.pavesMat,

        }

    }




    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui


        }
    }
    destroy() {
        this.isDestroyed = true
        anim.to(this.pavesMat.uniforms.u_appear, {
            value: 1,
            duration: 1,
            onComplete: () => {

                // Nettoyer les matériaux
                Object.values(this.materials).forEach(mat => {
                    if (mat.dispose) mat.dispose()
                })

                this.paves?.destroy()



                // Supprimer les références
                this.batiments = null
                this.road = null
                this.materials = null
                this.scene = null
                this.ressources = null
                this.experience = null
                this.targetPos = null
                this.time = null
                // 

            }
        })

    }




    update() {
        if (this.experience && this.experience.world) {
            this.targetX = this.experience.world.targetX
        }

        if (this.targetPos) {

            this.pavesMat.uniforms.u_targetPos.value = this.targetPos
        }
        if (this.batiments) {
            this.batiments.update()

        }
        if (this.paves) {
            this.paves.update()

        }


    }
}